import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';
import { ModalService } from '@app/core/services/modal.service';
import { DocPackTypeChapterSubmitEvent } from '../../doc-pack-type-chapter/doc-pack-type-chapter.component';
import { RowSelectedEvent } from '@ag-grid-community/core';
import { GetDocPackTypeParams } from '@app/services/doc-pack-type.service';

@Component({
    selector: 'tt-doc-pack-type-chapters',
    templateUrl: './doc-pack-type-chapters.component.html',
    styleUrls: ['./doc-pack-type-chapters.component.css'],
})
export class DocPackTypeChaptersComponent implements OnChanges {
    @Input()
    public params?: GetDocPackTypeParams;

    public grid?: GridOptions;

    public selectedDocPackTypeChapter?: string;

    constructor(private modal: ModalService) {}

    public async onChapterSubmit(event: DocPackTypeChapterSubmitEvent) {
        console.log(event);
        if (event.type === 'delete') {
            delete this.selectedDocPackTypeChapter;
            this.readGrid();
        } else if (event.type === 'update') {
            this.readGrid();
        } else if (event.type === 'new') {
            await this.readGrid();
            setTimeout(() => {
                this.grid?.gridfunc?.getGridApi().getRowNode(event.docpacktypechapter_keyno)?.setSelected(true, true);
                // this.selectedDocPackTypeChapter = event.docpacktypechapter_keyno;
            });
        }
    }

    public onRowSelected(event: RowSelectedEvent) {
        if (event.node.isSelected() && event.node.id !== this.selectedDocPackTypeChapter) {
            this.selectedDocPackTypeChapter = event.node.id;
        } else if (!event.node.isSelected() && this.selectedDocPackTypeChapter === event.node.id) {
            delete this.selectedDocPackTypeChapter;
        }
    }

    private createGrid() {
        if (!!this.params?.docpacktype_keyno) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('docpacktypechapter_grid')
                    .setLoadDataFunction({ method: 3278, parameters: () => this.params })
                    .setKendoConfig({ height: '100%', selectable: 'single' })
                    .addToolbarButton({
                        name: 'new_chapter',
                        text: 'docpacktypemenu_new_chapter',
                        func: () => (this.selectedDocPackTypeChapter = '0'),
                        icon: 'far fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true,
                    });
            }
        }
    }

    private async readGrid() {
        if (!this.grid) {
            this.createGrid();
        } else {
            await this.grid.gridfunc?.read(false);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.readGrid();
        }
    }
}
